import {
  apiRequest,
  riwayatangkakreditDetailJabfung,
} from "../../../../../services/adapters/kepegawaian/riwayatangkakreditService";

class DetailRepository {
  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      riwayatangkakreditDetailJabfung,
      {
        params: query,
      },
      true
    );
  };
}

export default DetailRepository;
